// store/rmPoSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rmPoData: {}, // key = rmPlannerId, value = array of PO objects
};

const rmPoSlice = createSlice({
  name: 'rmPo',
  initialState,
  reducers: {
    saveRmPoData: (state, action) => {
      const { rmPlannerId, rmPoList } = action.payload;
      state.rmPoData[rmPlannerId] = {
        poList: rmPoList
      };
    },

    togglePoChecked: (state, action) => {
      const { rmPlannerId, EBELN } = action.payload;

      const entry = state.rmPoData[rmPlannerId];
      if (!entry) return;

      const po = entry.poList.find((p) => p.EBELN === EBELN);
      if (po) {
        po.selectedPO = !po.selectedPO;
      }
    },

    resetRmPoData: (state) => {
      state.rmPoData = {};
    },
  },
});

export const { saveRmPoData, togglePoChecked, resetRmPoData } = rmPoSlice.actions;
export default rmPoSlice.reducer;
